let pendingFile: File | null = null;

export function setPendingImageSearchFile(file: File) {
  pendingFile = file;
}

export function consumePendingImageSearchFile(): File | null {
  const file = pendingFile;
  pendingFile = null;
  return file;
}